import { useEffect } from 'react';
import { HiOutlineUserGroup, HiOutlineCog, HiOutlineChartBar, HiOutlineHome, HiOutlineCreditCard} from 'react-icons/hi';
import { SidebarMenuItem } from '../types/types';

import { SidebarMenu } from '../components/sidebar/sidebar-menu';
import { ROUTES } from '../helpers/constants';
import { useRecoilState } from 'recoil';
import { userAtom } from '../services/atoms/auth.atoms';
import { HiOutlineCursorArrowRipple } from 'react-icons/hi2';

interface props {
  user?: any
}

const items: SidebarMenuItem[] = [
  {
    id: 'item-1',
    label: 'Clientes',
    icon: HiOutlineUserGroup,
    url: ROUTES.CLIENTS.route
  },
  {
    id: 'item-2',
    label: 'Evaluaciones',
    icon: HiOutlineCursorArrowRipple,
    url: ROUTES.PROCESS.route

  },
  {
    id:'item-3',
    label: 'Parámetros',
    icon: HiOutlineChartBar,
    url: ROUTES.PARAMS.route
  },
  {
    id: 'item-4',
    label: 'Configuraciones',
    icon: HiOutlineCog,
    url: ROUTES.CONFIGURATION.route
  },
  {
    id: 'item-5',
    label: 'Pagos por asignar',
    icon: HiOutlineCreditCard,
    url: ROUTES.GUEST_PAYMENTS.route
  },
];

const itemsAdmin: SidebarMenuItem[] = [
  {
    id: 'item-1',
    label: 'Inicio',
    icon: HiOutlineHome,
    url: ROUTES.CLIENTS.route
  },
  {
    id: 'item-2',
    label: 'Mi perfil',
    icon: HiOutlineCog,
    url: ROUTES.CONFIGURATION.route
  },
]

const Sidebar: React.FC<props> = ({ user }) => {
  const [userData, setUserData] = useRecoilState(userAtom);
  const fullName = (attributes: any) => `${attributes?.name?.split(' ')[0] || 'Usuario'} ${attributes['custom:surname']?.split(' ')[0] || 'Growme'}`;

  useEffect(() => {
    // setUserData((prevValues) => ({
    //   ...prevValues,
    //   data: {
    //     ...prevValues.data,
    //     displayName: fullName(user.data?.attributes || userData.data),
    //     name: user.data?.attributes?.name || '',
    //     surname: user.data?.attributes['custom:surname'] || '',
    //     email: user.data?.attributes?.email || '',
    //     phone_number: user.data?.attributes?.phone_number || '',
    //     'custom:surname': user.data?.attributes['custom:surname'] || '',
    //   }
    // }))
    // eslint-disable-next-line
  }, [user.data]);

  return <SidebarMenu items={userData?.data?.isSuperAdmin ? items : itemsAdmin} card={userData.data} />
};

export default Sidebar;